import { useCallback, useEffect, useState } from 'react';
import type { ReactionType } from '../types';

/** How long each one-shot reaction plays, in milliseconds. */
export const REACTION_DURATION: Record<ReactionType, number> = {
  happy: 850,
  feeding: 1200,
  discovery: 1800,
};

/**
 * Shared reaction controller for the Visual Lab batch. Keeps a single
 * one-shot reaction active at a time (priority guard) and clears it after its
 * duration. Reactions are skipped entirely under reduced motion.
 */
export function useReaction(reducedMotion: boolean) {
  const [reaction, setReaction] = useState<ReactionType | null>(null);

  const trigger = useCallback(
    (type: ReactionType) => {
      if (reducedMotion) return;
      setReaction((current) => (current ? current : type));
    },
    [reducedMotion]
  );

  useEffect(() => {
    if (!reaction) return;
    const timeout = window.setTimeout(() => setReaction(null), REACTION_DURATION[reaction]);
    return () => window.clearTimeout(timeout);
  }, [reaction]);

  return { reaction, trigger };
}
